<template>
  <base-page-component>
    <div>
      <b-row>
        <b-col lg="12">
          <b-card>
            <div slot="header">
              <strong>New Account</strong>
              <div class="pull-right">
                <button class="btn btn-warning" @click="$router.go('/accounts')"><i title="Back"
                                                                                    class="fa fa-arrow-left fa-lg text-white"></i>
                  <strong class="text-white">Return to Accounts</strong></button>
              </div>
            </div>
            <nav class="nav nav-pills nav-fill">
              <a class="nav-item nav-link nav-tab" v-bind:class="{ 'active':step1Active }" href="javascript:void(0);"
                 @click="changeStep(1)">Step 1</a>
              <a class="nav-item nav-link nav-tab" v-bind:class="{ 'active':step2Active,'disabled':step2Disabled }"
                 href="javascript:void(0);" @click="changeStep(2)" :disabled="step2Disabled">Step 2</a>
              <a class="nav-item nav-link nav-tab" v-bind:class="{ 'active':step3Active,'disabled':step3Disabled }"
                 href="javascript:void(0);" @click="changeStep(3)" :disabled="step3Disabled">Step 3</a>
            </nav>
            <b-row v-if="step1Active">
              <b-col lg="12">
                <b-col lg="6" class="mt-3">
                  <b-alert v-if="!account.validAccountNo && showVerifyError" variant="warning" class="text-center" show>
                    <strong>Note: </strong>This account number has already been used or is invalid.
                  </b-alert>
                </b-col>
                <b-col lg="8" class="my-3">
                  <b-row>
                    <b-col lg="2">
                      <b-form-group>
                        <label for="name">Account Number:</label>
                        <b-form-input type="text" v-model="account.desiredAccountNo" placeholder="Account Number"
                                      @change="account.validAccountNo = false"
                                      v-bind:class="{ 'is-valid':account.validAccountNo && account.desiredAccountNo.length > 0,'is-invalid':!account.validAccountNo && account.desiredAccountNo.length > 0 }"
                                      :disabled="true"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="2"/>
                    <b-col lg="2">
                      <b-form-group>
                        <label for="ddCountry">Country:</label><br/>
                        <b-dropdown v-model="countryCode" v-bind:key="countryCode.value" no-caret variant="outline-secondary" style="width:213px; height:35px; background-color: #ffffff !important;" class="mr-2 d-flex justify-content-between" >
                          <template v-slot:button-content>
                            <div class="d-flex justify-content-between">
                              <div v-if="countryCode.value === '0'" style="color: #000000 !important;">
                                All Countries
                              </div>
                              <div v-if="countryCode.value==='1'" style="color: #000000 !important;">
                                <img src="../assets/icons8-usa-96.png" class="flagImage" /> USA
                              </div>
                              <div v-if="countryCode.value==='2'" style="color: #000000 !important;">
                                <img src="../assets/icons8-canada-96.png" class="flagImage"/> CANADA
                              </div>
                              <div style="width:15px;float:right;">
                                <i class="fa fa-caret-down"></i>
                              </div>
                            </div>
                          </template>
                          <b-dropdown-item
                            :disabled="countryCodeOptions.disabled"
                            @click="selectCountryCode(option)"
                            v-for="option in countryCodeOptions" v-bind:key="option.value" style="width: 200px !important;">
                            <div>
                              <img v-if="option.src !== undefined" :src="option.src" class="flagImage">
                              {{option.text}}
                            </div>
                          </b-dropdown-item>
                        </b-dropdown>
                      </b-form-group>
                    </b-col>
                    <!--<b-col lg="3">
                      <b-form-group>
                        <label for="name">&nbsp;</label>
                        <b-button variant="info" @click="getAvaibleAccountNumber"><strong class="text-white">Get Account Number
                          </strong></b-button>
                      </b-form-group>-->
                    <!--</b-col>-->
                  </b-row>
                  <b-row>
                    <b-col lg="8">
                      <b-form-group>
                        <label for="address">Address</label>
                        <b-form-input type="text" v-model="account.address" placeholder="Address"
                                      @change="account.validAccountNo = false"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col lg="4">
                      <b-form-group>
                        <label for="ddCity">City</label>
                        <b-form-input type="text" v-model="account.city" placeholder="City"
                                      @change="account.validAccountNo = false"></b-form-input>
                      </b-form-group>
                    </b-col>
                    <b-col lg="2">
                      <b-form-group v-if="countryCode.value === '1'">
                        <label for="ddState">State</label>
                        <b-form-select id="ddState" v-model="account.state" @change="account.validAccountNo = false">
                          <option v-for="(option, name) in stateOptions" :value="name">{{ name }} - {{ option }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                      <b-form-group v-else>
                        <label for="ddState">Province</label>
                        <b-form-select id="ddState" v-model="account.state" @change="account.validAccountNo = false">
                          <option v-for="(option, name) in provinceOptions" :value="name">{{ name }} - {{ option }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                    <b-col lg="2">
                      <b-form-group v-if="IsUSA">
                        <label for="ddZip" >Zip Code</label>
                        <b-form-input type="text" v-model="account.zip" placeholder="Zip Code"
                                      @change="account.validAccountNo = false"></b-form-input>
                      </b-form-group>
                      <b-form-group v-else>
                        <label for="ddZip">Postal Code</label>
                        <b-form-input type="text" v-model="account.zip" placeholder="Postal Code"
                                      @change="account.validAccountNo = false"></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!match.length">
                    <b-col lg="12" class="my-2">
                      <b-button v-if="account.validAccountNo" variant="info" @click="triggerStep1"><strong
                        class="text-white">Next</strong> <i title="Back" class="fa fa-arrow-right fa-lg text-white"></i>
                      </b-button>
                      <b-button v-if="!account.validAccountNo" variant="warning" @click="verifyDesiredAccountNo"><strong
                        class="text-white">Verify</strong></b-button>
                    </b-col>
                  </b-row>
                </b-col>
                <b-row v-if="match.length">
                  <b-col v-if="!account.validAccountNo" lg="12" class="my-2">
                    <b-button variant="warning" @click="verifyDesiredAccountNo"><strong
                      class="text-white">Re-Verify</strong></b-button>
                  </b-col>
                  <b-col lg="6" class="mt-3">
                    <b-alert variant="warning" class="text-center" show><strong>Warning: </strong>One or more accounts
                      have been found with matching information. Proceed if you are certain you must.
                    </b-alert>
                    <table aria-busy="false" class="table b-table table-sm border-bottom mb-0 table-striped table-hover ">
                      <tbody>
                      <tr v-for="m in match" @click="gotoDetail(m)" class="pointer">
                        <td>{{ m.ACCOUNT_NUMBER }} </td>
                        <td>{{ m.NAME }}</td>
                        <td>{{ m.ADDRESS }}</td>
                        <td>{{ m.CITY }}</td>
                        <td>{{ m.STATE }}</td>
                        <td>{{ m.ZIP }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </b-col>
                  <b-col v-if="account.validAccountNo && !showVerifyError" lg="12" class="my-2">
                    <b-button variant="info" @click="triggerStep1"><strong class="text-white">Next</strong> <i
                      title="Back" class="fa fa-arrow-right fa-lg text-white"></i></b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="step2Active">
              <b-col lg="8">
                <b-row>
                  <b-col lg="7">
                    <b-form-group>
                      <label>Name</label>
                      <b-form-input type="text" v-model="account.name" placeholder="Name"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <b-form-group>
                      <label>Maximum Users</label>
                      <b-form-input type="number" v-model.number="account.subscription.MaxUsers" v-bind:readonly="true"
                                    placeholder="Max Users"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group>
                      <label>Maximum Simil. Users</label>
                      <b-form-input type="number" v-model.number="account.subscription.MaxSimultaniousUsers" v-bind:readonly="true"
                                    placeholder="Max Simil. Users"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col lg="4">
                    <b-form-group>
                      <label>Max Scans</label>
                      <b-form-input type="number" v-model.number="account.subscription.MaxScans" v-bind:readonly="true"
                                    placeholder="Max Scans"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <b-form-group>
                      <label for="betaDate">Cutoff:</label>
                      <date-picker v-model="account.subscription.Expires" :config="dpConfig" v-bind:readonly="true"></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col lg="5">
                    <b-form-group>
                      <label for="year1">Customer Type</label>
                      <div id="basicInlineCustomCheckboxes" role="group">
                        <b-form-checkbox v-model="account.subscription.RecurrentPayer" :disabled="true">Recurring Customer
                        </b-form-checkbox>
                        <div class="custom-control-inline" v-if="account.subscription.RecurrentPayer">
                          <label for="day1" style="width:110px;">Start Day:</label>
                          <b-form-select v-model="account.subscription.BillingCycleDay"
                                         :plain="true"
                                         :options="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]">
                          </b-form-select>
                        </div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <b-col lg="12">
                <b-button variant="info" @click="triggerStep2"><strong class="text-white">Next</strong> <i title="Back"
                                                                                                           class="fa fa-arrow-right fa-lg text-white"></i>
                </b-button>
              </b-col>
              <b-col lg="12">
                <b-alert v-if="!account.validAccountNo && showVerifyError" variant="warning" class="text-center" show>
                  <strong>Note: </strong>This account number has already been used or is invalid.
                </b-alert>
              </b-col>
            </b-row>
            <b-row v-if="step3Active" class="m-3">
              <b-col lg="12" class="my-3">
                <h3>Confirm New Account Info</h3>
              </b-col>
              <b-col lg="6" class="mt-3" v-if="!account.validAccountNo && showVerifyError">
                <b-alert variant="warning" class="text-center" show><strong>Note: </strong>This account number has
                  already been used or is invalid.
                </b-alert>
              </b-col>
              <b-col lg="8" class="ml-3">
                <b-row>
                  <b-col lg="4">
                    <label>Account #: {{account.accountNo}}</label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <label>Name: {{account.name}}</label>
                  </b-col>
                </b-row>
                <b-row class="container-fluid">
                  <b-col lg="12">
                    <label>Address: {{account.address}}</label>
                  </b-col>
                </b-row>
                <b-row class="container-fluid">
                  <b-col lg="12">
                    <label>{{account.city}}, {{account.state}} {{account.zip}}</label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <label>Maximum Users: {{account.subscription.MaxUsers}}</label>
                  </b-col>
                  <b-col lg="4">
                    <label>Maximum Simil. Users: {{account.subscription.MaxSimultaniousUsers}}</label>
                  </b-col>
                  <b-col lg="4">
                    <label>Max Scans: {{account.subscription.MaxScans}}</label>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col lg="4">
                    <label for="betaDate">Cutoff: {{account.subscription.Expires | formatDate}}</label>
                  </b-col>
                  <b-col lg="5">
                    <label>Recurring Customer: {{account.subscription.RecurrentPayer ? 'Yes' : 'No'}}
                      <slot v-if="account.subscription.RecurrentPayer"> Day: {{account.subscription.BillingCycleDay}}
                      </slot>
                    </label>
                  </b-col>
                </b-row>
              </b-col>

              <b-col lg="12" class="mt-3">
                <b-button variant="info" @click="triggerStep3"><strong class="text-white">Confirm &amp; Create</strong>
                  <i title="Create account" class="fa fa-arrow-right fa-lg text-white"></i></b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </base-page-component>
</template>

<script>
import axios from 'axios'
import {basePageMixin} from '@/mixins/basePageMixin'
import 'bootstrap/dist/css/bootstrap.css'
import datePicker from 'vue-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.css'
import cSwitch from '../components/Switch'
import {setTimeout} from 'timers'
import usImage from '../assets/icons8-usa-96.png'
import caImage from '../assets/icons8-canada-96.png'

export default {
  components: {
    datePicker,
    cSwitch
  },
  mixins: [basePageMixin],
  created () {
    let self = this
    self.countryCode = self.countryCodeOptions[0]
    this.getAvaibleAccountNumber()
    setTimeout(function () {
      self.toggleloader(false)
    }, 100)
  },
  data () {
    return {
      showVerifyError: false,
      step1Active: true,
      step2Active: false,
      step3Active: false,
      step2Disabled: true,
      step3Disabled: true,
      dpConfig: {
        format: 'MM/DD/YYYY',
        useCurrent: false
      },
      account: {
        ID: -1,
        accountNo: 0,
        desiredAccountNo: '',
        validAccountNo: false,
        name: '',
        address: null,
        city: null,
        state: null,
        zip: null,
        country: '1',
        latitude: null,
        longitude: null,
        subscription: {
          RecurrentPayer: false,
          BillingCycleDay: 1,
          MaxUsers: 5,
          MaxSimultaniousUsers: null,
          MaxScans: 0,
          Expires: new Date((new Date().getFullYear() + 3), new Date().getMonth(), new Date().getDate())
        }
      },
      match: [],
      stateOptions: {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      },
      provinceOptions: {
        'AB': 'Alberta',
        'BC': 'British Columbia',
        'MB': 'Manitoba',
        'NB': 'New Brunswick',
        'NL': 'Newfoundland and Labrador',
        'NT': 'Northwest Territories',
        'NS': 'Nova Scotia',
        'NU': 'Nunavut',
        'ON': 'Ontario',
        'PE': 'Prince Edward Island',
        'QC': 'Quebec',
        'SK': 'Saskatchewan',
        'YT': 'Yukon'
      },
      countryCodeOptions: [
        {
          value: '1',
          text: 'USA',
          src: usImage
        },
        {
          value: '2',
          text: 'CANADA',
          src: caImage
        }
      ],
      country: undefined,
      IsUSA: true
    }
  },
  methods: {
    changeStep (i) {
      let self = this

      if (self['step' + i + 'Disabled']) {
        return
      }
      self.step1Active = false
      self.step2Active = false
      self.step3Active = false

      switch (i) {
        case 1:
          self.step1Active = true
          break
        case 2:
          self.step2Active = true
          break
        case 3:
          self.step3Active = true
          break
      }
    },
    getAvaibleAccountNumber () {
      let self = this

      let obj = {
      }

      axios.post('/api/accounts/GetAvaibleAccountNumber')
        .then(response => {
          if (response.status === 204) {
            self.showWarning('There is no information about this account')
          } else {
            self.account.desiredAccountNo = response.data
            // self.showNotification('Account Number loaded')
          }
        })
        .catch(error => {
          self.handleError(error)
        }).then(() => {
          self.toggleloader(false)
        })
    },
    
    gotoDetail (account) {
      let self = this
      self.$router.push('/account/' + account.ACCOUNT_NUMBER)
    },
    verifyDesiredAccountNo () {
      let self = this
      let warningArr = []

      if (!self.account.desiredAccountNo) {
        warningArr.push('Account Number')
      }
      if (!self.HasValue(self.account.address)) {
        warningArr.push('Address')
      }
      if (!self.HasValue(self.account.city)) {
        warningArr.push('City')
      }
      if (self.countryCode.value === '1') {
        if (!self.HasValue(self.account.state)) {
          warningArr.push('State')
        }
      } else {
        if (!self.HasValue(self.account.state)) {
          warningArr.push('Province')
        }
      }
      if (!self.HasValue(self.account.zip)) {
        if (self.countryCode.value === '1') {
          warningArr.push('Zip Code')
        } else {
          warningArr.push('Postal Code')
        }
      }
      if (self.countryCode.value === '1' && isNaN(self.account.zip)) {
        warningArr.push('Zip Code must be valid zip code for country USA')
      }
      if (warningArr.length > 0) {
        self.showWarning(`Required field(s): ${warningArr.join(', ')}`)
        return
      }

      if (!self.HasValue(self.countryCode)) {
        self.account.country = self.countryCode.value
      }

      let obj = {
        account: self.account
      }

      self.toggleloader(true)

      axios.post('/api/accounts/getmatchingaccounts', obj, self.axiosConfig)
        .then(response => {
          if (response.data.MATCH !== undefined || response.data.MATCH.length) {
            self.match = response.data.MATCH
          }

          if (response.data.DUP_ACCOUNTNO !== undefined && response.data.DUP_ACCOUNTNO) {
            self.showVerifyError = true
            self.account.validAccountNo = false
          } else {
            self.account.validAccountNo = true
          }
          self.account.latitude = response.data.LAT
          self.account.longitude = response.data.LNG
        })
        .catch(error => {
          self.handleError(error)
        }).then(() => {
          self.toggleloader(false)
        })
    },
    saveAccount () {
      let self = this
      let warningArr = []

      if (!self.account.accountNo) {
        warningArr.push('Account Number')
      }
      if (!self.HasValue(self.account.name)) {
        warningArr.push('Account Name')
      }
      if (!self.HasValue(self.account.address)) {
        warningArr.push('Address')
      }
      if (!self.HasValue(self.account.city)) {
        warningArr.push('City')
      }

      if (self.countryCode.value === '1') {
        if (!self.HasValue(self.account.state)) {
          warningArr.push('State')
        }
      } else {
        if (!self.HasValue(self.account.state)) {
          warningArr.push('Province')
        }
      }

      if (!self.HasValue(self.account.zip)) {
        if (self.countryCode.value === '1') {
          warningArr.push('Zip Code')
        } else {
          warningArr.push('Postal Code')
        }
      }
      if (self.countryCode.value === '1' && isNaN(self.account.zip)) {
        warningArr.push('Zip Code must be valid zip code for country USA')
      }
      if (warningArr.length > 0) {
        self.showWarning(`Required field(s): ${warningArr.join(', ')}`)
        return
      }

      if (self.countryCode.value !== undefined) {
        self.account.country = self.countryCode.value
      }

      let obj = {
        account: self.account
      }
      self.toggleloader(true)
      axios.post('/api/accounts/createaccount', obj)
        .then(() => {
          self.showInformation('Account Created')
          self.$router.push('/account/' + this.account.accountNo)
        })
        .catch(error => {
          self.handleError(error)
          if (error !== undefined && error.response !== undefined && error.response.data === 'Duplicate Account Number') {
            self.account.validAccountNo = false
          }
        }).then(() => {
          self.toggleloader(false)
        })
    },
    triggerStep1 () {
      let self = this
      if (!self.account.validAccountNo) {
        return
      }

      self.step2Disabled = false
      self.account.accountNo = self.account.desiredAccountNo
      self.changeStep(2)
    },
    triggerStep2 () {
      let self = this
      let warning = false

      if (!self.account.validAccountNo) {
        return
      }

      let warningArr = []

      if (!self.account.name) {
        warningArr.push('Account Name')
      }

      if (warningArr.length > 0) {
        self.showWarning(`Required field(s): ${warningArr.join(', ')}`)
        return
      }

      self.step3Disabled = false
      self.changeStep(3)
    },
    triggerStep3 () {
      let self = this

      if (!self.account.validAccountNo) {
        return
      }
      self.saveAccount()
    },
    selectCountryCode (option) {
      this.account.state = undefined
      this.countryCode = option
      if (this.countryCode.value === '1') {
        this.IsUSA = true
      } else {
        this.IsUSA = false
      }
    },
    HasValue (val) {
      return val !== undefined && val !== null && val !== ''
    }
  },
  filters: {
    formatDate: function (str) {
      if (!str) {
        return ''
      }
      str = new Date(str)
      return ((str.getMonth() < 9) ? '0' : '') + (str.getMonth() + 1) + '/' +
        ((str.getDate() < 10) ? '0' : '') + str.getDate() + '/' + str.getFullYear()
    }
  }
}
</script>

<style scoped>
.nav-tab {
  border: 2px solid #c8ced3;
}
tr.pointer {
  cursor: pointer;
}
.nav-tab.disabled {
  background-color: #FFFFFF;
  /*border: 2px solid #c8ced3;*/
}
/* local styles */
.flagImage {
  width: 25px;
  height: 25px;
}
/*
  .btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle, .show > .btn-secondary.dropdown-toggle-no-caret {
    color: #000000 !important;
    background-color: #FFFFFF !important;
    border-color: #7e99a7;
  }
  .btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle, .show > .btn-outline-secondary.dropdown-toggle-no-caret {
    color: #000000 !important;
    background-color:  #FFFFFF !important;
  }
  .btn-outline-secondary:hover {
    color: #000000;
    background-color:  #FFFFFF !important;
  }
  .btn-secondary:hover {
    color: #000000;
    background-color:  #FFFFFF !important;
  }
  */

</style>



// WEBPACK FOOTER //
// src/views/AccountCreate.vue